var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.prefix)),_c('k-num',{attrs:{"value":_vm.value / 100,"sign":_vm.sign,"unit":_vm.unit,"skin":_vm.skin,"fixed":_vm.fixLength}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }